import { useState } from "react";
import axios from "axios";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";

import "../App.css";

const API = "https://slimlinehardwarefittings.com/backend";

export default function BlogDashboard() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    category: "",
    tags: "",
    excerpt: "",
    content: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // INPUT CHANGE
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // MAIN BLOG IMAGE
  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
  };

  // SLUG
  const generateSlug = (title = "") => {
    return title
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .substring(0, 120);
  };

  // PUBLISH BLOG
  const publishBlog = async () => {
    if (!form.title || !form.content) {
      alert("Title aur Content required");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("title", form.title);
      formData.append("slug", generateSlug(form.title));
      formData.append("category", form.category);
      formData.append("tags", form.tags);
      formData.append("excerpt", form.excerpt);
      formData.append("content", form.content);

      if (image) {
        formData.append("image", image);
      }

      const res = await axios.post(`${API}/blogs.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("BLOG CREATED:", res.data);

      alert("✅ Blog Published Successfully");

      setForm({
        title: "",
        category: "",
        tags: "",
        excerpt: "",
        content: "",
      });

      setImage(null);

      navigate("/blogs");
    } catch (err) {
      console.log("ERROR:", err);

      alert(err.response?.data?.message || "❌ Server Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blog-container">
      <h1>Create Blog</h1>

      <input
        type="text"
        name="title"
        placeholder="Title"
        value={form.title}
        onChange={handleChange}
      />

      {/* Main Featured Image */}
      <input
        type="file"
        accept="image/*"
        onChange={handleImage}
      />

      <input
        type="text"
        name="category"
        placeholder="Category"
        value={form.category}
        onChange={handleChange}
      />

      <input
        type="text"
        name="tags"
        placeholder="Tags"
        value={form.tags}
        onChange={handleChange}
      />

      <textarea
        name="excerpt"
        placeholder="Excerpt"
        value={form.excerpt}
        onChange={handleChange}
      />

      <Editor
     apiKey="gpz2mciidg2zhyjs2jssxkwtd0ias51s0gx3u61yavmdmifa"
        value={form.content}
        init={{
          height: 500,
          menubar: true,

          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
            "image_dimensions: true,"
          ],

          toolbar:
            "undo redo | blocks | " +
            "bold italic underline strikethrough | " +
            "alignleft aligncenter alignright alignjustify | " +
            "bullist numlist outdent indent | " +
            "link image media table | " +
            "removeformat code fullscreen",

          image_title: true,
          automatic_uploads: true,
          file_picker_types: "image",

          file_picker_callback: (cb, value, meta) => {
            const input = document.createElement("input");

            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");

            input.onchange = function () {
              const file = this.files[0];

              const reader = new FileReader();

              reader.onload = () => {
                cb(reader.result, {
                  title: file.name,
                });
              };

              reader.readAsDataURL(file);
            };

            input.click();
          },
        }}
        onEditorChange={(content) =>
          setForm((prev) => ({
            ...prev,
            content,
          }))
        }
      />

      <button
        className="blog-btn"
        onClick={publishBlog}
        disabled={loading}
      >
        {loading ? "Publishing..." : "Publish Blog"}
      </button>
    </div>
  );
}